var React = require('react');

function FbLove (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"none","d":"M0 0h70.33v70.33H0z"}))),React.createElement("g",{"data-name":"Layer 2","key":1},React.createElement("g",{"clipPath":"url(#a)","data-name":"Layer 5"},[React.createElement("path",{"d":"M70.46 35.23A35.23 35.23 0 1 1 35.23 0a35.23 35.23 0 0 1 35.23 35.23","fill":"#f0546a","key":0}),React.createElement("path",{"d":"M46.05 18.18c-9.62 0-10.82 7.75-10.82 7.75S34 18.18 24.41 18.18c-9.25 0-11.95 9.44-10.82 14.48 3 13.34 21.64 22.69 21.64 22.69S53.9 46 56.88 32.66c1.12-5-1.58-14.48-10.83-14.48","fill":"#fff","fillRule":"evenodd","key":1})]))]);
}

FbLove.defaultProps = {"viewBox":"0 0 70.46 70.46"};

module.exports = FbLove;

FbLove.default = FbLove;
